"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("../mixins");
var _hooks = require("../../../hooks");
var _constants = require("../constants");
var _excluded = ["children", "linkRef"];
var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "link__StyledLink"
})(["", " font-weight:", ";font-size:1rem;line-height:1.5rem;text-decoration:underline;cursor:pointer;", " &:hover,&:focus{filter:brightness(60%);}"], _mixins.mixins.font, _constants.FONT_WEIGHTS.normal, _mixins.mixins.inlineIcon);
var Link = exports.Link = function Link(_ref) {
  var children = _ref.children,
    linkRef = _ref.linkRef,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useBonsai = (0, _hooks.useBonsai)(),
    linkColor = _useBonsai.linkColor,
    secondaryFont = _useBonsai.secondaryFont;
  return /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({
    target: "_top"
  }, props, {
    ref: linkRef,
    $color: linkColor,
    $font: secondaryFont
  }), children);
};